// extracted by mini-css-extract-plugin
export default {"applePayContainer":"ovjup9PbIickWJGTWStmf"};